import { SUPPORTED_LANGS, DEFAULT_LANG } from "../i18n";
import { isNonLocalized } from "./locale";

// Lingua attiva letta dal primo segmento dell'URL corrente (source of truth).
export function getActiveLang() {
  try {
    const seg = window.location.pathname.split("/")[1];
    return SUPPORTED_LANGS.includes(seg) && seg !== DEFAULT_LANG ? seg : DEFAULT_LANG;
  } catch (e) {
    return DEFAULT_LANG;
  }
}

// Alla PRIMA visita del browser: se la lingua del browser e' EN/DE e siamo su un
// URL italiano localizzabile, reindirizza (full reload) alla versione tradotta.
// Ritorna true se ha avviato un redirect (per interrompere il render iniziale).
const BOT_RE = /bot|crawl|spider|slurp|headless|prerender|lighthouse|chrome-lighthouse|gptbot|claude|perplexity|bingpreview|facebookexternalhit|embedly|quora|whatsapp|telegram/i;
export function isBot() {
  try {
    return !!navigator.webdriver || BOT_RE.test(navigator.userAgent || "");
  } catch (e) {
    return false;
  }
}

export function maybeRedirectForLocale() {
  try {
    if (isBot()) return false;
    if (localStorage.getItem("torri_lang")) return false;
    const path = window.location.pathname;
    const seg = path.split("/")[1];
    const currentLang = SUPPORTED_LANGS.includes(seg) && seg !== DEFAULT_LANG ? seg : DEFAULT_LANG;
    const browser = (navigator.language || "").slice(0, 2).toLowerCase();
    const detected = SUPPORTED_LANGS.includes(browser) ? browser : DEFAULT_LANG;
    localStorage.setItem("torri_lang", detected);
    if (currentLang === DEFAULT_LANG && (browser === "en" || browser === "de" || browser === "fr") && !isNonLocalized(path)) {
      const target = "/" + browser + (path === "/" ? "" : path);
      window.location.replace(target + window.location.search + window.location.hash);
      return true;
    }
  } catch (e) {
    /* localStorage/navigator non disponibili */
  }
  return false;
}
